/** Live input sanitizer: keep spaces the user is typing; strip clipboard junk. */
export function sanitizeSearchInput(raw: string): string {
  return String(raw ?? "")
    .replace(/\uFEFF/g, "")
    .replace(/[\u200B-\u200D\u2060]/g, "")
    .replace(/\r\n|\r|\n/g, " ");
}

/** Query sent to APIs / filters: trim + collapse whitespace. */
export function normalizeSearchQuery(raw: string): string {
  return sanitizeSearchInput(raw).replace(/\s+/g, " ").trim();
}

export function matchesSearchHaystack(haystack: unknown, query: string): boolean {
  const q = normalizeSearchQuery(query).toLowerCase();
  if (!q) return true;
  return String(haystack ?? "").toLowerCase().includes(q);
}
